import { FC } from 'react';
import AddEditDocument from '../../../../components/addEditDocument/addEditDocument';
import {
  useProfileDocumentsState,
  useProfileDocumentsActions,
} from '../../contexts/profileDocuments.context';
import { TDocument } from '../../../../../apis/documents/documents.interfaces';

const ProfileAddEditDocument: FC = () => {
  const {
    selectedDocument,
    isOpenAddDocumentDialog,
    isDocumentLoading,
    documentErrorMessage,
    isCreateMode,
    isEditMode,
  } = useProfileDocumentsState();

  const {
    setIsOpenAddDocumentDialog,
    addDocument,
    updateDocument,
    setSelectedDocument,
    setIsCreateMode,
    setIsEditMode,
    setIsDocumentLoading,
    setDocumentErrorMessage,
  } = useProfileDocumentsActions();

  const handleClose = () => {
    setIsOpenAddDocumentDialog(false);
    setSelectedDocument(null);
    setIsCreateMode(false);
    setIsEditMode(false);
    setIsDocumentLoading(false);
    setDocumentErrorMessage('');
  };

  const handleSubmit = (document: TDocument) => {
    if (isCreateMode) {
      addDocument(document);
    } else if (isEditMode) {
      updateDocument(document);
    }
    handleClose();
  };

  const onUploadProgress = (status: boolean, message: string) => {
    setIsDocumentLoading(status);
    setDocumentErrorMessage(message);
  };

  return (
    <AddEditDocument
      isOpen={isOpenAddDocumentDialog}
      onClose={handleClose}
      onSubmit={handleSubmit}
      onUploadProgress={onUploadProgress}
      document={isEditMode && selectedDocument ? selectedDocument : null}
      isLoading={isDocumentLoading}
      errorMessage={documentErrorMessage}
    />
  );
};

export default ProfileAddEditDocument;
